import { render, staticRenderFns } from "./Pick.vue?vue&type=template&id=3da87e95&"
import script from "./Pick.vue?vue&type=script&lang=js&"
export * from "./Pick.vue?vue&type=script&lang=js&"
import style0 from "./Pick.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports